// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Directive, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ctsGantryGridHighlight]',
  standalone: true,
})
export class CtsGantryGridHighlightDirective {
  @Input() ctsGantryGridHighlight: string = 'cts-not-defined-selector';

  private readonly CLASS_NAME = 'cts-gantry-grid-highlight';

  private elements: NodeListOf<Element> | undefined;

  public constructor(private readonly renderer2: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.elements = this.getElements();
    this.elements.forEach((el) => this.renderer2.addClass(el, this.CLASS_NAME));
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.elements = this.getElements();
    this.elements.forEach((el) =>
      this.renderer2.removeClass(el, this.CLASS_NAME),
    );
  }

  private getElements(): NodeListOf<Element> {
    this.elements ??= document.querySelectorAll(
      `.${this.ctsGantryGridHighlight}`,
    );

    return this.elements;
  }
}
